import qs from 'query-string'
import {getAccessToken, getTenant} from "./jetms-interop";

const get = (url) => {
  return fetch(url, {
    headers: {
      'Authorization': 'Bearer ' + getAccessToken(),
      'Content-Type': 'application/json',
      'x-je-tenant': getTenant()
    },
  })
}

const put = (url, data) => {
  return fetch(url, {
    headers: {
      'Authorization': 'Bearer ' + getAccessToken(),
      'Content-Type': 'application/json',
      'x-je-tenant': getTenant()
    },
    body: JSON.stringify(data),
    method: 'PUT',
  })
}

const post = (url, data) => {
  return fetch(url, {
    headers: {
      'Authorization': 'Bearer ' + getAccessToken(),
      'Content-Type': 'application/json',
      'x-je-tenant': getTenant()
    },
    body: JSON.stringify(data),
    method: 'POST',
  })
}

const GetById = (id) => {
  return get(window.env.api + '/applications/deliveryconfiguration/restaurants/' + id)
}

const GetByIds = (ids) => {
  return post(window.env.api + '/applications/deliveryconfiguration/restaurants', { ids: ids })
}

const SearchByName = (name, offset, limit) => {
  let sortOrder = ['name', 'offset', 'limit']
  let qsOptions = { sort: (m, n) => sortOrder.indexOf(m) >= sortOrder.indexOf(n) }

  return get(window.env.api + '/applications/deliveryconfiguration/restaurants?' + qs.stringify({
    name: name,
    offset: !offset ? undefined : offset,
    limit: limit
  }, qsOptions))
}

const SearchByPoolId = (poolId, offset, limit) => {
  let sortOrder = ['poolId', 'offset', 'limit']
  let qsOptions = { sort: (m, n) => sortOrder.indexOf(m) >= sortOrder.indexOf(n) }

  return get(window.env.api + '/applications/deliveryconfiguration/restaurants?' + qs.stringify({
    poolId: poolId,
    searchByPoolId: true,
    offset: !offset ? undefined : offset,
    limit: limit
  }, qsOptions))
}

const GetRestaurantPoolSchedule = (id, details) => {
  return get(window.env.api + `/applications/deliveryconfiguration/restaurants/${id}/pool-schedule`)
}


const UpdateRestaurantPoolSchedule = (id, details) => {
  return put(window.env.api + `/applications/deliveryconfiguration/restaurants/${id}/pool-schedule`, { data: details })
}

const GetLogs = (id, offset, limit) => {
  return get(window.env.api + '/applications/deliveryconfiguration/restaurants/' + id + '/logs?offset=' + offset + '&limit=' + limit)
}

const GetSummary = (id) => {
  return get(window.env.api + '/applications/deliveryconfiguration/restaurants/' + id + '/summary')
}

export default { GetById, SearchByName, SearchByPoolId, GetRestaurantPoolSchedule, UpdateRestaurantPoolSchedule, GetByIds, GetLogs, GetSummary }




// WEBPACK FOOTER //
// ./src/api/restaurants.js